import Map, { MapMarker } from 'components/map';
import { Box, Heading, Stack, Text, TextBlock } from 'components/ui';
import { FC } from 'react';
import styled from 'styled-components';
import { breakpoints } from 'styles/theme';
import { formatAddress } from 'utils/sanity';

interface CTAMapProps {
  location: Sanity.Schema.Location;
}

const Wrapper = styled(Box)`
  --background-color: var(--color-pink);
  --height: 400px;

  display: grid;
  align-items: center;

  @media screen and (min-width: ${breakpoints.medium}) {
    grid-template-columns: minmax(475px, 1fr) 3fr;
  }
`;

const AddressBox = styled(Box).attrs({ as: 'address' })`
  --padding: var(--space-6);

  font-style: normal;
  white-space: pre;
`;

const CTAMap: FC<CTAMapProps> = ({ location, children }) => {
  const coords: any = [
    location.mapLocation?.lng || 0,
    location.mapLocation?.lat || 0,
  ];

  return (
    <Wrapper>
      <AddressBox>
        <Stack space={{ initial: 2, large: 4, xLarge: 6 }}>
          <TextBlock>
            <Heading level='h1' color='white'>
              {location.name}
            </Heading>
            <Text>
              {location.phone && (
                <>
                  Ph. {location.phone} <br />
                </>
              )}
              {formatAddress(location)}
            </Text>
          </TextBlock>
          {children}
        </Stack>
      </AddressBox>

      <Map center={coords} zoom={[14]}>
        <MapMarker coordinates={coords} />
      </Map>
    </Wrapper>
  );
};

export default CTAMap;
